import { Link } from "react-router-dom";
import ApplyMembershipModal from "../../components/ApplyMembershipModal";

export default function LandingHeader() {
  return (
    <header className="border-b border-[#24272B] sticky top-0 z-20" style={{ background: "#0E1012" }}>
      <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="nav-logo">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera Ventures</span>
          <span className="t-cap text-muted-s ml-2 hidden sm:inline fig">solera.vc</span>
        </div>
        <div className="flex items-center gap-4 sm:gap-6">
          <Link to="/membership" className="t-label hover:!text-[#E8E6E1] hidden sm:inline" data-testid="landing-membership-link">Membership</Link>
          <ApplyMembershipModal trigger={
            <button className="t-label hover:!text-[#E8E6E1]" data-testid="landing-apply-link">Apply</button>
          } />
          <Link to="/login" className="btn-ghost !py-2 !px-5" data-testid="landing-login-link">Login</Link>
        </div>
      </div>
    </header>
  );
}
